/**
 * 支付中签约 第二版本，同第一版本目前共用页面组件
 * 仅路由不同，增加全局 reversionId 参数区分
 */
import Vue from 'vue';
import '@/styles/common.less';
import { bridge, env, monitor, ReversionId, Runtime } from '@/common';
import App from '@/views/indexv2/Index.vue';
import config from '@/config/project-info';
import { storeInstance } from '@/store';

bridge.setBounces(0);
Vue.config.productionTip = false;
Vue.config.errorHandler = (e, vm, msg) => monitor.vueErrorHandler(e, vm, msg);
env.setReversionId(ReversionId.ImproveCTR);
if (env.runtime === Runtime.Test) {
  const covReport = () => import('@era/coverage-report');
  covReport()
    .then(({ initOrange }) => {
      initOrange({ projectKey: config.projectKey, commitId: config.commitId });
    })
    .catch(() => {});
}

new Vue({
  render: (h) => h(App),
  store: storeInstance(),
}).$mount('#app');
